import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Icon } from '@codex/icons';

import ActiveFilters from './ActiveFilters';
import {
  getCurrentActivePriceFilterLabel,
  getActiveFilterLabelsForRegularItem
} from './utils/filterHelpers';
import renderLink from './presentionalComponents/LinkWrapper';
import FiltersMobileButtons from './presentionalComponents/FiltersMobileButtons';
import { resetAllFilters } from '../../reduck/listingPagePages.reduck';
import UISettings from '../../settings/UISettings';
import {
  getActiveListingPage,
  getNumberOfActiveFiltersOnActiveListingPage
} from '../../reduck/selectors';

import {
  FilterContainerHeader,
  BoldFilterHeader,
  FilterLP,
  FilterContainerBody,
  FilterHeader,
  FilterHeaderClosed,
  FilterHeaderSelectedOptions
} from './styled';

function MobileFilterList({
  onFilterListItemClick,
  currentActiveMinPrice,
  currentActiveMaxPrice,
  productsRequestErrorMessage,
  noProductsOnPage,
  filtersFromSearchLabs,
  numberOfResultsLabel,
  onResetButtonClick,
  onDoneButtonClick,
  numberOfActiveFilters
}) {
  const tariffSegmentLinkLabel = UISettings.get(
    'component.listing-page-products.tariff-segment-link-label'
  );
  const tariffSegmentLinkTarget = UISettings.get(
    'component.listing-page-products.tariff-segment-link-target'
  );
  const tariff = tariffSegmentLinkLabel &&
    tariffSegmentLinkTarget && {
    label: tariffSegmentLinkLabel,
    target: tariffSegmentLinkTarget
  };

  function renderFilterItem(filter) {
    return (
      <FilterLP className={'dc-filter-lp dc-filter--closed'} closed key={filter.id}>
        <FilterHeader // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
          className={'dc-filter__header'}
          onClick={() => {
            onFilterListItemClick(filter.id);
          }}
          onKeyPress={() => {
            onFilterListItemClick(filter.id);
          }}
        >
          <FilterHeaderClosed className={'dc-filter__header--closed'}>
            {filter.label === 'segment_id' ? 'Browse by category' : filter.label}
          </FilterHeaderClosed>

          {filter.values.findIndex((value) => value.selected) !== -1 ? (
            <FilterHeaderSelectedOptions className={'dc-filter__header-selected-options'}>
              {getActiveFilterLabelsForRegularItem(filter.values, filter.id === 'rounded_score')}
            </FilterHeaderSelectedOptions>
          ) : null}
          <Icon icon={'ChevronRight'} size={'large'} rotate={0} />
        </FilterHeader>
      </FilterLP>
    );
  }

  function renderPriceFilterListItem() {
    return (
      <FilterLP className={'dc-filter-lp dc-filter--closed'} closed>
        <FilterHeader // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
          className={'dc-filter__header'}
          onClick={() => {
            onFilterListItemClick('price');
          }}
          onKeyPress={() => {
            onFilterListItemClick('price');
          }}
        >
          <FilterHeaderClosed className={'dc-filter__header--closed'}>
            Price
            {/* TODO: add to translations */}
          </FilterHeaderClosed>
          {typeof currentActiveMinPrice !== 'undefined' && (
            <FilterHeaderSelectedOptions className={'dc-filter__header-selected-options'}>
              {getCurrentActivePriceFilterLabel(currentActiveMinPrice, currentActiveMaxPrice)}
            </FilterHeaderSelectedOptions>
          )}
          <Icon icon={'ChevronRight'} size={'large'} rotate={0} />
        </FilterHeader>
      </FilterLP>
    );
  }

  function renderSegmentFilterFirst(filter) {
    return filter.id === 'segment_id' ? renderFilterItem(filter) : null;
  }

  function checkForSegmentFilters(checkedFilters) {
    if (checkedFilters[0].id === 'segment_id') {
      return checkedFilters.filter((filter) => filter.id !== 'segment_id');
    }
    return checkedFilters;
  }

  return (
    <>
      {numberOfActiveFilters !== 0 && (
        <ActiveFilters filtersFromSearchLabs={filtersFromSearchLabs} />
      )}
      <FilterContainerHeader className={'dc-filter-container__header'}>
        <BoldFilterHeader className={'dc-filter-container__header--bold'}>
          Filter by:
          {' '}
        </BoldFilterHeader>
        {numberOfResultsLabel}
      </FilterContainerHeader>
      {tariff && renderLink(tariff, 'mobile')}
      <FilterContainerBody className={'dc-filter-container__body'}>
        {filtersFromSearchLabs &&
          filtersFromSearchLabs.length > 0 &&
          renderSegmentFilterFirst(filtersFromSearchLabs[0])}
        {renderPriceFilterListItem()}
        {filtersFromSearchLabs && filtersFromSearchLabs.length > 0
          ? checkForSegmentFilters(filtersFromSearchLabs).map((filter) => renderFilterItem(filter))
          : null}
        <FiltersMobileButtons
          resetButtonDisabled={numberOfActiveFilters === 0}
          resetButtonLabel={'Reset filters'} // TODO: add to translations
          applyButtonLabel={'Done'} // TODO: add to translations
          onResetButtonClick={onResetButtonClick}
          onApplyButtonClick={onDoneButtonClick}
          showErrorMessage={!!productsRequestErrorMessage}
          showWarningMessage={noProductsOnPage}
        />
      </FilterContainerBody>
    </>
  );
}

MobileFilterList.propTypes = {
  numberOfResultsLabel: PropTypes.string.isRequired,
  numberOfActiveFilters: PropTypes.number.isRequired,
  currentActiveMinPrice: PropTypes.string,
  currentActiveMaxPrice: PropTypes.string,
  productsRequestErrorMessage: PropTypes.string,
  noProductsOnPage: PropTypes.bool,
  filtersFromSearchLabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      openedByDefault: PropTypes.bool,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          selected: PropTypes.bool.isRequired,
          count: PropTypes.string
        })
      ).isRequired
    })
  ),
  onFilterListItemClick: PropTypes.func,
  onDoneButtonClick: PropTypes.func,
  onResetButtonClick: PropTypes.func
};

MobileFilterList.defaultProps = {
  currentActiveMinPrice: undefined,
  currentActiveMaxPrice: undefined,
  productsRequestErrorMessage: null,
  noProductsOnPage: false,
  filtersFromSearchLabs: undefined,
  onFilterListItemClick: () => {},
  onDoneButtonClick: () => {},
  onResetButtonClick: () => {}
};

const mapStateToProps = (state) => ({
  numberOfResultsLabel:
    getActiveListingPage(state).categoryTotalProductCount === 1
      ? `${getActiveListingPage(state).categoryTotalProductCount} result` // TODO: add to translations
      : `${getActiveListingPage(state).categoryTotalProductCount} results`, // TODO: add to translations
  numberOfActiveFilters: getNumberOfActiveFiltersOnActiveListingPage(state),
  currentActiveMinPrice:
    typeof getActiveListingPage(state).pageAttributes.price_min !== 'undefined'
      ? getActiveListingPage(state).pageAttributes.price_min
      : undefined,
  currentActiveMaxPrice:
    typeof getActiveListingPage(state).pageAttributes.price_max !== 'undefined'
      ? getActiveListingPage(state).pageAttributes.price_max
      : undefined,
  productsRequestErrorMessage: state.listingPage.commonData.xhrStatus.productsRequestErrorMessage,
  noProductsOnPage: getActiveListingPage(state).productList.length === 0
});

const mapDispatchToProps = (dispatch) => ({
  onResetButtonClick: () => {
    dispatch(resetAllFilters());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilterList);
